// Labels and colors for iRacing categories and license classes, shared by the
// refreshed data pages.

export const CATEGORIES = ['sports_car', 'formula_car', 'oval', 'dirt_road', 'dirt_oval'];

export const CATEGORY_LABELS = {
  sports_car: 'Sports car',
  formula_car: 'Formula car',
  oval: 'Oval',
  dirt_road: 'Dirt road',
  dirt_oval: 'Dirt oval',
  road: 'Road',
};

// iRacing license colors, with Pro lightened so it reads on the dark theme.
export const LICENSE_COLORS = {
  Rookie: '#e5574b',
  D: '#e67e22',
  C: '#f1c40f',
  B: '#2ecc71',
  A: '#4c8dff',
  Pro: '#c3c8d0',
  'Pro/WC': '#c3c8d0',
};

export const licenseLetter = (licenseClass) => (licenseClass === 'Rookie' ? 'R' : licenseClass || '?');
